export const ALERTA = 'alerta';
export const ALERTA_POPUP = 'popup';